export var ErrorBoundaryName;
(function (ErrorBoundaryName) {
    ErrorBoundaryName["Achievements"] = "Achievements";
    ErrorBoundaryName["AllFeed"] = "AllFeed";
    ErrorBoundaryName["AllTopics"] = "AllTopics";
    ErrorBoundaryName["AnnouncementNotificationBar"] = "AnnouncementNotificationBar";
    ErrorBoundaryName["AnswersAnalytics"] = "AnswersAnalytics";
    ErrorBoundaryName["App"] = "App";
    ErrorBoundaryName["AskMeAnything"] = "AskMeAnything";
    ErrorBoundaryName["AttachableLinkFeed"] = "AttachableLinkFeed";
    ErrorBoundaryName["AudienceAnalytics"] = "AudienceAnalytics";
    ErrorBoundaryName["BookmarkFeed"] = "BookmarkFeed";
    ErrorBoundaryName["CampaignAnalytics"] = "CampaignAnalytics";
    ErrorBoundaryName["CampaignCreateModalBoundary"] = "CampaignCreateModalBoundary";
    ErrorBoundaryName["CampaignEditModalBoundary"] = "CampaignEditModalBoundary";
    ErrorBoundaryName["CampaignFeed"] = "CampaignFeed";
    ErrorBoundaryName["CampaignHeader"] = "CampaignHeader";
    ErrorBoundaryName["CampaignSidebarSponsors"] = "CampaignSidebarSponsors";
    ErrorBoundaryName["CampaignSidebarOrganizers"] = "CampaignSidebarOrganizers";
    ErrorBoundaryName["CampaignEntityBoundary"] = "CampaignEntityBoundary";
    ErrorBoundaryName["Card"] = "Card";
    ErrorBoundaryName["CuratedThreadList"] = "CuratedThreadList";
    ErrorBoundaryName["DirectMessagePublisher"] = "DirectMessagePublisher";
    ErrorBoundaryName["DiscoveryFeed"] = "DiscoveryFeed";
    ErrorBoundaryName["DiscoveryNetworkQuestionFeed"] = "DiscoveryNetworkQuestionFeed";
    ErrorBoundaryName["DraftFeed"] = "DraftFeed";
    ErrorBoundaryName["DraftThread"] = "DraftThread";
    ErrorBoundaryName["EditPublisher"] = "EditPublisher";
    ErrorBoundaryName["EditTeamsMeeting"] = "EditTeamsMeeting";
    ErrorBoundaryName["EventAttendeeInfoBar"] = "EventAttendeeInfoBar";
    ErrorBoundaryName["EventCard"] = "EventCard";
    ErrorBoundaryName["EventCreationModalBoundary"] = "EventCreationModalBoundary";
    ErrorBoundaryName["EventPublisher"] = "EventPublisher";
    ErrorBoundaryName["EventsDiscoveryBanner"] = "EventsDiscoveryBanner";
    ErrorBoundaryName["GroupEvents"] = "GroupEvents";
    ErrorBoundaryName["EventEditModalBoundary"] = "EventEditModalBoundary";
    ErrorBoundaryName["GroupLiveEventsBanner"] = "GroupLiveEventsBanner";
    ErrorBoundaryName["FeaturedTopics"] = "FeaturedTopics";
    ErrorBoundaryName["FollowedTopics"] = "FollowedTopics";
    ErrorBoundaryName["FollowNotificationsPickerButton"] = "FollowNotificationsPickerButton";
    ErrorBoundaryName["FlightControlPanel"] = "FlightControlPanel";
    ErrorBoundaryName["GroupAdminStepper"] = "GroupAdminStepper";
    ErrorBoundaryName["GlobalAnswersAnalytics"] = "GlobalAnswersAnalytics";
    ErrorBoundaryName["GroupCreateModalBoundary"] = "GroupCreateModalBoundary";
    ErrorBoundaryName["GroupEditModalBoundary"] = "GroupEditModalBoundary";
    ErrorBoundaryName["GroupFeedNoNewPostsBanner"] = "GroupFeedNoNewPostsBanner";
    ErrorBoundaryName["GroupFeed"] = "GroupFeed";
    ErrorBoundaryName["GroupHeader"] = "GroupHeader";
    ErrorBoundaryName["GroupHeaderActions"] = "GroupHeaderActions";
    ErrorBoundaryName["GroupHeaderCompact"] = "GroupHeaderCompact";
    ErrorBoundaryName["GroupInsights"] = "GroupInsights";
    ErrorBoundaryName["GroupMembershipBulkUpload"] = "GroupMembershipBulkUpload";
    ErrorBoundaryName["GroupMemberCard"] = "GroupMemberCard";
    ErrorBoundaryName["GroupPopularTopics"] = "GroupPopularTopics";
    ErrorBoundaryName["GroupQnAInsights"] = "GroupQnAInsights";
    ErrorBoundaryName["GroupSidebar"] = "GroupSidebar";
    ErrorBoundaryName["GroupSidebarEvents"] = "GroupSidebarEvents";
    ErrorBoundaryName["HomeFeed"] = "HomeFeed";
    ErrorBoundaryName["InboxFeed"] = "InboxFeed";
    ErrorBoundaryName["InboxThread"] = "InboxThread";
    ErrorBoundaryName["LeadersDiscovery"] = "LeadersDiscovery";
    ErrorBoundaryName["LeaderEmployees"] = "LeaderEmployees";
    ErrorBoundaryName["LeaderHighlighted"] = "LeaderHighlighted";
    ErrorBoundaryName["LeadersManagement"] = "LeadersManagement";
    ErrorBoundaryName["LiveEvent"] = "LiveEvent";
    ErrorBoundaryName["LiveEventHeader"] = "LiveEventHeader";
    ErrorBoundaryName["LiveEventFeed"] = "LiveEventFeed";
    ErrorBoundaryName["LiveEventSidebar"] = "LiveEventSidebar";
    ErrorBoundaryName["LivePersonaCard"] = "LivePersonaCard";
    ErrorBoundaryName["MediaLightbox"] = "MediaLightbox";
    ErrorBoundaryName["MediaPost"] = "MediaPost";
    ErrorBoundaryName["MessageAttachments"] = "MessageAttachments";
    ErrorBoundaryName["MomentsList"] = "MomentsList";
    ErrorBoundaryName["MomentsListItem"] = "MomentsListItem";
    ErrorBoundaryName["MomentsModal"] = "MomentsModal";
    ErrorBoundaryName["MomentsPlayer"] = "MomentsPlayer";
    ErrorBoundaryName["MoreForYouFeed"] = "MoreForYouFeed";
    ErrorBoundaryName["MyLeaders"] = "MyLeaders";
    ErrorBoundaryName["MyTopics"] = "MyTopics";
    ErrorBoundaryName["NavigationCommunities"] = "NavigationCommunities";
    ErrorBoundaryName["NetworkAnalytics"] = "NetworkAnalytics";
    ErrorBoundaryName["NetworkQuestion"] = "NetworkQuestion";
    ErrorBoundaryName["NetworkQuestionAdmin"] = "NetworkQuestionAdmin";
    ErrorBoundaryName["NetworkQuestionInbox"] = "NetworkQuestionInbox";
    ErrorBoundaryName["NetworkSwitcherPanel"] = "NetworkSwitcherPanel";
    ErrorBoundaryName["NotificationItem"] = "NotificationItem";
    ErrorBoundaryName["NotificationPanel"] = "NotificationPanel";
    ErrorBoundaryName["OlderReplyPaginationControls"] = "OlderReplyPaginationControls";
    ErrorBoundaryName["PersonalAnalytics"] = "PersonalAnalytics";
    ErrorBoundaryName["PinnedThreads"] = "PinnedThreads";
    ErrorBoundaryName["PromotedFeed"] = "PromotedFeed";
    ErrorBoundaryName["ProposedTopics"] = "ProposedTopics";
    ErrorBoundaryName["PublisherAttachments"] = "PublisherAttachments";
    ErrorBoundaryName["PublisherTopicsBar"] = "PublisherTopicsBar";
    ErrorBoundaryName["RealtimeSubscription"] = "RealtimeSubscription";
    ErrorBoundaryName["RealtimeConnectionEventsSubscription"] = "RealtimeConnectionEventsSubscription";
    ErrorBoundaryName["Reply"] = "Reply";
    ErrorBoundaryName["ReplyPublisher"] = "ReplyPublisher";
    ErrorBoundaryName["SearchResult"] = "SearchResult";
    ErrorBoundaryName["SearchResultTopics"] = "SearchResultTopics";
    ErrorBoundaryName["SearchResultsList"] = "SearchResultsList";
    ErrorBoundaryName["SharedMessage"] = "SharedMessage";
    ErrorBoundaryName["SharedMessageTile"] = "SharedMessageTile";
    ErrorBoundaryName["ShareMessagePublisher"] = "ShareMessagePublisher";
    ErrorBoundaryName["SharePointConfigurationPane"] = "SharePointConfigurationPane";
    ErrorBoundaryName["ShareTeamsMeetingPublisher"] = "ShareTeamsMeetingPublisher";
    ErrorBoundaryName["StorylineHome"] = "StorylineHome";
    ErrorBoundaryName["Stepper"] = "Stepper";
    ErrorBoundaryName["StorylineAllFeed"] = "StorylineAllFeed";
    ErrorBoundaryName["StorylineDiscoveryFeed"] = "StorylineDiscoveryFeed";
    ErrorBoundaryName["StorylineFollowedFeed"] = "StorylineFollowedFeed";
    ErrorBoundaryName["SuggestedTopics"] = "SuggestedTopics";
    ErrorBoundaryName["TeachingBubbleWithSoftDismiss"] = "TeachingBubbleWithSoftDismiss";
    ErrorBoundaryName["TeamsMeeting"] = "TeamsMeeting";
    ErrorBoundaryName["Thread"] = "Thread";
    ErrorBoundaryName["ThreadAnalyticsV2"] = "ThreadAnalyticsV2";
    ErrorBoundaryName["ThreadStarter"] = "ThreadStarter";
    ErrorBoundaryName["ThreadStarterPublisher"] = "ThreadStarterPublisher";
    ErrorBoundaryName["ThreadStarterTopicsBar"] = "ThreadStarterTopicsBar";
    ErrorBoundaryName["TopicFeatureModalBoundary"] = "TopicFeatureModalBoundary";
    ErrorBoundaryName["TopicFeed"] = "TopicFeed";
    ErrorBoundaryName["TopicNetworkQuestionFeed"] = "TopicNetworkQuestionFeed";
    ErrorBoundaryName["TopicSidebar"] = "TopicSidebar";
    ErrorBoundaryName["TopicUnified"] = "TopicUnified";
    ErrorBoundaryName["TrendingTopics"] = "TrendingTopics";
    ErrorBoundaryName["UserFeed"] = "UserFeed";
    ErrorBoundaryName["UserHeader"] = "UserHeader";
    ErrorBoundaryName["UserProfileCard"] = "UserProfileCard";
    ErrorBoundaryName["UserSidebar"] = "UserSidebar";
    ErrorBoundaryName["UserStorylineFeed"] = "UserStorylineFeed";
    ErrorBoundaryName["UserHeaderActions"] = "UserHeaderActions";
    ErrorBoundaryName["WritingAssistantChatMessage"] = "WritingAssistantChatMessage";
})(ErrorBoundaryName || (ErrorBoundaryName = {}));
//# sourceMappingURL=types.js.map